<template>
  <div am-formula-meaning>
    <p v-if="Object.keys(meaning).length || edited">Meaning</p>
    <div
      v-for="(mean, index) in meaning"
      :key="mean.key"
      :class="!edited ? '_margin-left:1/2' : null"
    >
      <p class="_margin:0" v-if="!edited">
        {{ mean.key }} - {{ typeof mean.value === 'string' ? mean.value : mean.value?.name }}
      </p>
      <div v-else class="_display:flex _align-items:center _margin-top:1/2 _margin-bottom:1/4">
        <div style="width:100px" class="_margin-right:1/2">
          <i-input
            placeholder="key"
            type="number"
            v-model="mean.key"
            @change="store.dispatch('formula/putParEdited', {id: id, data: meaning, tag: 'meaning'})"
          />
        </div>
        -
        <div style="width: calc(100% - 120px)" class="_margin-left:1/2">
          <i-input
            v-if="typeof mean.value === 'string'"
            placeholder="value"
            v-model="mean.value"
            @change="store.dispatch('formula/putParEdited', {id: id, data: meaning, tag: 'meaning'})"
          />
          <p v-else>{{ mean.value?.name }}</p>
        </div>
        <div class="_margin-left:1/4" v-if="typeof mean.value === 'string'">
          <svg viewBox="0 0 24 24" am-icon="color" @click="delMeaning(index)">
            <use xlink:href="@/assets/icons.svg#minus"  x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
      </div>
    </div>
    <svg
      v-if="edited && ((meaning.length && typeof meaning[0].value === 'string') || !meaning.length)"
      am-icon
      viewBox="0 0 24 24"
      class="_margin-top:1/2"
      @click="emit('add')"
    >
      <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
    </svg>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { defineProps, defineEmits } from 'vue'
const emit = defineEmits(['add', 'del'])
const store = useStore()
const props = defineProps(['meaning', 'edited', 'id'])
const delMeaning = (index) => {
  emit('del', index)
  store.dispatch('formula/putParEdited', { id: props.id, data: props.meaning, tag: 'meaning' })
}
</script>

<style lang="scss">
[am-formula-meaning] {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
}
</style>
